import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSearchParams, useNavigate } from 'react-router-dom';
import './instructions.css';
import { isIOSVersionHigherThan26Version } from '../../utils/getUserAgentParser';

const INSTRUCTIONS_LIST_PATH = '/instructions_list';

const Instructions = () => {
  const { t } = useTranslation('basic');
  const [searchParams] = useSearchParams();
    const navigate = useNavigate();

    const key = searchParams.get('key');

  const goBack = () => navigate(INSTRUCTIONS_LIST_PATH);

  const isIOS26Version = isIOSVersionHigherThan26Version();

  // Helper function to validate URL
  const isValidUrl = (string) => {
    try {
      new URL(string);
      return true;
    } catch (_) {
      return false;
    }
  };

  if (!key) {
    return (
      <div className={`instructions-container ${isIOS26Version ? 'ios26_top-safe-area' : ''}`}>
        <div className="instructions-error">
          <h2>{t("instruction_not_found")}</h2>
          <p>{t("specify_video_url")}</p>
          <p>Пример: /instructions?key=https://example.com/video.mp4</p>
        </div>
      </div>
    );
  }

  if (!isValidUrl(key)) {
    return (
      <div className={`instructions-container ${isIOS26Version ? 'ios26_top-safe-area' : ''}`}>
        <div className="instructions-error">
          <h2>{t("invalid_url")}</h2>
          <p>{t("key_must_contain_url")}</p>
          <p>Пример: /instructions?key=https://example.com/video.mp4</p>
        </div>
      </div>
    );
  }

  return (
    <div className={`instructions-container ${isIOS26Version ? 'ios26_top-safe-area' : ''}`}>
      <div className="instructions-backWrap">
        <button
          type="button"
          className="instructions-backBtn"
          onClick={goBack}
          aria-label={t('back')}
        >
          <span className="instructions-backArrow" aria-hidden>
            ←
          </span>
        </button>
      </div>
      <div className="instructions-video">
        <video
          controls
          autoPlay
          width="100%"
          height="auto"
          poster=""
        >
          <source src={key} type="video/mp4" />
          {t("browser_not_support_video_tag")}
        </video>
      </div>
    </div>
  );
};

export default Instructions; 